import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, vModelText as _vModelText, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "form-group" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-sm-10" };
const _hoisted_4 = ["value"];
const _hoisted_5 = { class: "col-sm-2" };
const _hoisted_6 = { class: "statiBox" };
const _hoisted_7 = { class: "label" };
const _hoisted_8 = {
    key: 0,
    class: "modificheRichieste"
};
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "form-group" };
const _hoisted_12 = { class: "text-right" };
const _hoisted_13 = { class: "d-flex justify-content-between" };
const _hoisted_14 = { class: "form-group" };
const _hoisted_15 = { class: "form-group" };
const _hoisted_16 = ["value"];
const _hoisted_17 = { class: "text-right mt-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_qualita_task = _resolveComponent("qualita-task");
    const _component_stand_by_task = _resolveComponent("stand-by-task");
    const _component_mini_spinner = _resolveComponent("mini-spinner");
    const _directive_label = _resolveDirective("label");
    return (_openBlock(), _createElementBlock("div", null, [
        _cache[23] || (_cache[23] = _createElementVNode("h4", null, "Gestione task", -1)),
        _createElementVNode("div", _hoisted_1, [
            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Aggiorna stato", -1)),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _withDirectives(_createElementVNode("select", {
                        class: "form-control mr-2",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.newStato) = $event))
                    }, [
                        _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "Seleziona", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statiTask, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: i,
                                value: item
                            }, _toDisplayString(item), 9, _hoisted_4));
                        }), 128))
                    ], 512), [
                        [_vModelSelect, _ctx.newStato]
                    ]),
                    _cache[13] || (_cache[13] = _createElementVNode("hr", null, null, -1)),
                    _createVNode(_component_qualita_task, {
                        task: _ctx.task,
                        newStato: _ctx.newStato
                    }, null, 8, ["task", "newStato"]),
                    _cache[14] || (_cache[14] = _createElementVNode("hr", null, null, -1)),
                    _createVNode(_component_stand_by_task, {
                        task: _ctx.task,
                        newStato: _ctx.newStato
                    }, null, 8, ["task", "newStato"]),
                    _cache[15] || (_cache[15] = _createElementVNode("hr", null, null, -1))
                ]),
                _createElementVNode("div", _hoisted_5, [
                    (_ctx.updating)
                        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            class: "btn btn-blue",
                            type: "button",
                            onClick: _cache[1] || (_cache[1] =
                                //@ts-ignore
                                (...args) => (_ctx.updateStatus && _ctx.updateStatus(...args)))
                        }, " Aggiorna stato "))
                ])
            ])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.stateHistory, (item, i) => {
                    return (_openBlock(), _createElementBlock("li", {
                        class: "mb-1",
                        key: i
                    }, [
                        _createTextVNode(_toDisplayString(_ctx.$filters.date(item.date, null, true)) + " - ", 1),
                        _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_7, [
                            _createTextVNode(_toDisplayString(item.text), 1)
                        ])), [
                            [_directive_label, item.text]
                        ])
                    ]));
                }), 128))
            ])
        ]),
        _cache[24] || (_cache[24] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("button", {
            type: "button",
            class: "float-right btn btn-blue",
            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.showAddModifica = !_ctx.showAddModifica))
        }, _toDisplayString(_ctx.showAddModifica ? 'Annulla' : 'Aggiungi richiesta'), 1),
        _cache[25] || (_cache[25] = _createElementVNode("h4", null, "Modifiche richieste", -1)),
        (!_ctx.showAddModifica)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (_ctx.task.modificheHistory.length > 0)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.task.modificheHistory, (item, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                                class: "mb-1",
                                key: i
                            }, _toDisplayString(_ctx.$filters.date(item.date, null, true)) + " - " + _toDisplayString(item.text), 1));
                        }), 128))
                    ]))
                    : _createCommentVNode("", true),
                _cache[17] || (_cache[17] = _createElementVNode("p", null, "Nessuna modifica richiesta", -1))
            ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                    _cache[18] || (_cache[18] = _createElementVNode("label", null, [
                        _createElementVNode("b", null, "Inserisci una descrizione della modifica richiesta")
                    ], -1)),
                    _withDirectives(_createElementVNode("textarea", {
                        class: "form-control",
                        ref: "input",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.modificaText) = $event)),
                        rows: "4"
                    }, null, 512), [
                        [_vModelText, _ctx.modificaText]
                    ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                    (_ctx.savingModifica)
                        ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-green",
                            onClick: _cache[4] || (_cache[4] =
                                //@ts-ignore
                                (...args) => (_ctx.saveModifica && _ctx.saveModifica(...args)))
                        }, "Salva"))
                ])
            ])),
        _cache[26] || (_cache[26] = _createElementVNode("hr", null, null, -1)),
        _cache[27] || (_cache[27] = _createElementVNode("h4", null, "Consegna", -1)),
        _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
                _cache[19] || (_cache[19] = _createElementVNode("label", null, "Mostra allegati al cliente", -1)),
                _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-checkbox ml-2", { checked: _ctx.task.showDeliveryAttachments }]),
                    onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.task.showDeliveryAttachments = !_ctx.task.showDeliveryAttachments))
                }, null, 2)
            ]),
            _createElementVNode("button", {
                type: "button",
                onClick: _cache[6] || (_cache[6] =
                    //@ts-ignore
                    (...args) => (_ctx.sendStandbyMail && _ctx.sendStandbyMail(...args))),
                class: "btn btn-warning"
            }, " Invia mail GRATUITA "),
            _createElementVNode("div", null, [
                _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[7] || (_cache[7] =
                        //@ts-ignore
                        (...args) => (_ctx.sendModifichePronteMail && _ctx.sendModifichePronteMail(...args))),
                    class: "btn btn-success mr-3"
                }, " Invia mail MODIFICHE PRONTE "),
                _createElementVNode("button", {
                    type: "button",
                    onClick: _cache[8] || (_cache[8] =
                        //@ts-ignore
                        (...args) => (_ctx.sendDisegniProntiMail && _ctx.sendDisegniProntiMail(...args))),
                    class: "btn btn-green"
                }, " Invia mail DISEGNI PRONTI ")
            ])
        ]),
        (_ctx.customer && (_ctx.customer.isAccountPadre || _ctx.customer.clienteParentIdentifier))
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _cache[21] || (_cache[21] = _createElementVNode("hr", null, null, -1)),
                _cache[22] || (_cache[22] = _createElementVNode("h4", null, "Spostamento", -1)),
                _createElementVNode("div", _hoisted_15, [
                    _cache[20] || (_cache[20] = _createElementVNode("label", null, "Nuovo proprietario del task", -1)),
                    _withDirectives(_createElementVNode("select", {
                        class: "form-control",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.taskOwner) = $event)),
                        onChange: _cache[10] || (_cache[10] =
                            //@ts-ignore
                            (...args) => (_ctx.setNewOwner && _ctx.setNewOwner(...args)))
                    }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.familyMembers, (item, i) => {
                            return (_openBlock(), _createElementBlock("option", {
                                key: i,
                                value: item
                            }, _toDisplayString(item.name), 9, _hoisted_16));
                        }), 128))
                    ], 544), [
                        [_vModelSelect, _ctx.taskOwner]
                    ])
                ])
            ], 64))
            : _createCommentVNode("", true),
        _cache[28] || (_cache[28] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_17, [
            (_ctx.deleting)
                ? (_openBlock(), _createBlock(_component_mini_spinner, { key: 0 }))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "btn btn-sm btn-danger",
                    type: "button",
                    onClick: _cache[11] || (_cache[11] =
                        //@ts-ignore
                        (...args) => (_ctx.removeTask && _ctx.removeTask(...args)))
                }, " Elimina e restituisci crediti "))
        ])
    ]));
}
